// extracted by mini-css-extract-plugin
export default {"accountTemplatesContainer":"AccountTemplates_accountTemplatesContainer__esp5O"};